module.exports = __webpack_public_path__ + "edb6a51cb75b75b5b26ba361f0bf72d2.pdf";